import { render } from "./chromeOSDownloadInstructions.vue?vue&type=template&id=49770b7e&ts=true"
import script from "./chromeOSDownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./chromeOSDownloadInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__